/*!

=========================================================
* Argon Dashboard React - v1.2.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// reactstrap components
import { Card, CardBody, CardTitle, Container, Row, Col } from "reactstrap";

const UsersTableHeader = () => {
  return (
    <>
      <div className="header pb-8 pt-5 pt-md-8 kd-bg">
        <Container fluid>
          <div className="header-body">
            {/* Card stats */}
            
          </div>
        </Container>
      </div>
    </>
  );
};

export default UsersTableHeader;
